module.exports = __webpack_public_path__ + "img/CK.20689cdd.png";